import classNames from "classnames";
import GoogleLogo from "../../../images/google-logo.svg?react";
import AuthButton from "../AuthButton";

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}

export default function GoogleButton({ children, className, onClick }: Props) {
  return (
    <AuthButton
      buttonClass={classNames(className, "google-button")}
      imageClass="google-logo"
      textClass="google-text"
      logo={GoogleLogo}
      onClick={onClick}
    >
      {children}
    </AuthButton>
  );
}
